<template>
  <admin-layout title="Candidatos(as)" menu="Candidatos">
    <div class="row mb-2">
      <div class="col-lg-12">
        <div class="row mb-3">
          <div class="col-lg-2">
            <div class="form-group color-dark-purple mb-0">
              <h4 class="label-bold">CANDIDATO(A)S</h4>
            </div>
          </div>
          <div class="col-lg-3">
            <inertia-link :href="`/recruiters/talent_banks/candidate/new`">
              <button class="btn-new-job">CADASTRAR CANDIDATO(A)</button>
            </inertia-link>
          </div>
          <div class="col-lg-3">
            <a
              target="_blank"
              :href="'/recruiters/csv_candidates.csv'"
            >
              <button
                class="btn-new-job"
                style="height: 38px; width: 95%"
              >
                DOWNLOAD CANDIDATOS(AS)
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-lg-3 pl-0 pr-0">
        <select
          class="form-control"
          v-model="action"
          @change="changeAction"
          :disabled="candidates_selected.length == 0"
        >
          <option disabled value="0">AÇÕES</option>

          <option value="1">COPIAR CANDIDATOS(AS) PARA VAGA</option>
          <option value="2">ENVIAR EMAIL PARA OS(AS) CANDIDATOS(AS)</option>
        </select>
      </div>
      <div class="col-lg-1">
        <button
          class="btn btn-primary"
          @click="viewBlockOrTable = !viewBlockOrTable"
        >
          <font-awesome-icon v-if="viewBlockOrTable" icon="table" />
          <font-awesome-icon v-if="!viewBlockOrTable" icon="list" />
        </button>
      </div>
      <div class="col-lg-4"></div>
      <div class="col-lg-1">
        <button
          @click="clearSearch"
          type="button"
          v-if="
            state.terms_search.length > 0 ||
            state.sub_search_selected.length > 0 ||
            state.where['_and']
          "
          class="btn btn-primary right"
        >
          <i class="fas fa-sort-amount-down"></i>
        </button>
      </div>
      <div class="col-lg-3 col-xs-12">
        <div class="form-group mb-0 has-search d-flex justify-content-end">
          <span
            class="fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
          ></span>
          <input
            type="text"
            @click="openSearch"
            v-model="search"
            v-on:keyup.enter="searchCandidates"
            class="form-control no_border"
            style="padding: 0px"
          /><br />
          <div
            v-if="
              state.terms_search.length > 0 ||
              Object.keys(state.where).length !== 0
            "
            class="col-lg-2"
          ></div>
          <span
            class="label-bold color-dark-purple right"
            style="position: absolute; top: 40px"
          >
            {{ candidateCount }} CANDIDATO(A)S
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-lg-2 col-xs-12"
        style="border: 2px solid rgb(204 204 204)"
      >
        <div class="mt-3">
          <h4 class="f17 font-weight-semi-bold text-uppercase mb-3">
            Candidatos(as)
          </h4>

          <div
            v-for="filter in candidates_filter"
            v-bind:key="filter.text"
            class="form-group d-flex align-items-center justify-content-between f13 text-lh-md text-secondary mb-1"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                v-model="filter.value"
                @click="
                  searchCandidates(
                    !filter.value
                      ? { candidate_curriculum_text: { _not: '' } }
                      : false
                  )
                "
                class="custom-control-input checkfilter"
                :id="filter.text"
              />

              <label
                class="custom-control-label first-letter"
                :for="filter.text"
                >Curriculum</label
              >
            </div>
          </div>
        </div>
        <Aggregators
          :aggregators="aggregators"
          :aggs_translate="aggs_translate"
          :agg_format="agg_format"
        />
      </div>
      <div class="col-lg-10 col-xs-12">
        <BlockView :talent_banks="talent_banks" v-if="viewBlockOrTable" />
        <TableView :talent_banks="talent_banks" v-if="!viewBlockOrTable" />
      </div>
    </div>

    <div
      class="center position-absolute loading-gif"
      :class="{ 'd-none': !loading || firstLoad }"
    >
      <img src="/images/loading.gif" alt="loading-gif" />
    </div>
    <div class="col-lg-12">
      <v-pagination
        v-model="currentPage"
        :page-count="pageCount"
        class="justify-content-center"
        :class="firstLoad ? 'd-none' : 'd-flex'"
        :classes="bootstrapPaginationClasses"
      ></v-pagination>
    </div>
  </admin-layout>
</template>

<script>
import Header from "components/Table/Header.vue";
import SearchIndex from "components/Search/Index.vue";
import Aggregators from "components/Search/Aggregators.vue";
import OrderTable from "components/OrderTable.vue";
import vPagination from "vue-plain-pagination";
import { formatDistanceStrict } from "date-fns";
import { ptBR } from "date-fns/locale";
import { state, gettersMap, mutationsMap } from "store/table.js";
import BlockView from "./IndexInBlock.vue";
import TableView from "./IndexInTable.vue";
import CopyCandidates from "components/CopyCandidates.vue";
import SendMail from "components/SendMail.vue";

export default {
  components: {
    OrderTable,
    vPagination,
    Header,
    BlockView,
    TableView,
    Aggregators,
  },
  data: () => ({
    talent_banks: [],
    firstLoad: true,
    loading: false,
    currentPage: 1,
    candidateCount: "",
    action: 0,
    candidates_selected: [],
    pageCount: 1,
    search: "",
    state: state,
    candidates_filter: [{ text: "Curriculum", value: false }],
    aggregators: [],
    agg_format: [
      "skills_a",
      "experiences_a",
      "educations_a",
      "gender",
      "city",
      "state",
      "languages",
    ],
    aggs_translate: {
      skills_a: "Habilidades técnicas",
      experiences_a: "Cargo",
      educations_a: "Educação",
      gender: "Sexo",
      city: "Cidade",
      state: "Estado",
      languages: "Idiomas",
    },
    order: "",
    field: "",
    viewBlockOrTable: false,
    formatDistanceStrict: formatDistanceStrict,
    ptBR: ptBR,
    gettersMap: gettersMap,
    filter: {},
    gender: [
      "Homen",
      "Mulher",
      "Transgêneros",
      "Não identificado",
      "Não cadastrado",
    ],
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  watch: {
    currentPage: function () {
      this.searchCandidates();
    },
    "state.order"(new_state) {
      this.field = Object.keys(new_state)[0];
      this.order = new_state[this.field];

      this.searchCandidates();
    },
    "state.filters"(new_state) {
      this.filter = new_state;
      this.searchCandidates();
    },
    "state.search_flag"(new_state) {
      console.log(gettersMap.getWhere());
      this.search = gettersMap.getTermsSearch().join(",");
      this.searchCandidates(gettersMap.getWhere());
    },
  },
  mounted() {
    eventBus.$on("candidateSelected", (candidates) => {
      this.candidates_selected = candidates;
      if (candidates.length == 0) this.action = 0;
    });

    this.searchCandidates();
  },
  methods: {
    changeAction() {
      if (this.action == 1) {
        this.copyCandidates();
        return;
      }

      this.$modal.show(
        SendMail,
        {
          candidates: this.candidates_selected,
        },
        {
          width: "80%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("resetSelected");
          },
        }
      );
    },
    copyCandidates() {
      this.$modal.show(
        CopyCandidates,
        {
          candidates: this.candidates_selected,
        },
        {
          width: "60%",
          height: "auto",
          scrollable: false,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("resetSelected");
          },
        }
      );
    },
    showField(field, monetary = false) {
      if (field == null || "" || "" || field.length == 0 || field == 0) {
        return "Não Informado";
      } else {
        return monetary ? this.formatCurrency(field) : field;
      }
    },
    clearSearch() {
      mutationsMap.setTermsRequired([]);
      mutationsMap.setTermsOptionals([]);
      mutationsMap.setTermsExcluded([]);
      mutationsMap.setTermsSearch([]);
      mutationsMap.setWhere({});
      mutationsMap.setAmountSubSearch([0]);
      mutationsMap.setSubSearchValue([]);
      mutationsMap.setSubSearchOptions([]);
      mutationsMap.setSubSearchSelected([]);
      this.search = "";
      this.searchCandidates();
    },
    openSearch() {
      this.search = "";
      this.$modal.show(
        SearchIndex,
        {
          url_suggestion: "/recruiters/talent_banks/candidates/search",
          field_suggestion: [
            { field: "skills_a", name: "Habilidades Técnicas" },
            { field: "experiences_a", name: "Cargo" },
            { field: "educations_a", name: "Formação / Curso" },
          ],
          sub_search: [
            { field: "candidate_name", name: "Nome", type: "string" },
            { field: "candidate_email", name: "Email", type: "string" },
            { field: "mobile_phone", name: "Telefone", type: "string" },
            {
              field: "candidate_curriculum_text",
              name: "Currículo",
              type: "string",
            },
            { field: "created_at", name: "Data cadastro", type: "timestamp" },
            {
              field: "updated_at",
              name: "Data atualização",
              type: "timestamp",
            },
            {
              field: "gender",
              name: "Genero",
              type: "array",
              data: [
                "Homem",
                "Mulher",
                "Transgêneros",
                "Não identificado",
                "Não cadastrado",
              ],
            },
            {
              field: "skills_a",
              name: "Habilidades técnicas",
              type: "autocomplete",
              url: "/recruiters/skills/search",
              term_search: "skills",
              track: "name",
              data: [],
            },
            {
              field: "city",
              name: "Cidade",
              type: "autocomplete",
              url: "/cities",
              term_search: "cities",
              track: "text",
              data: [],
            },
            {
              field: "educations_a",
              name: "Curso",
              type: "autocomplete",
              url: "/study_areas",
              term_search: "study_areas",
              track: "name",
              data: [],
            },
            {
              field: "experiences_a",
              name: "Cargo",
              type: "autocomplete",
              url: "/occupations",
              term_search: "occupations",
              track: "name",
              data: [],
            },
            {
              field: "remuneration",
              name: "Remuneração",
              type: "float",
              data: [0, 0],
            },
          ],
        },
        {
          width: "80%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    makeTerms(new_state, operator) {
      let search_builder = [];
      if (new_state == "") {
        this.search = "";
      } else {
        for (let i in new_state) {
          search_builder.push(operator + new_state[i]);
        }
      }
      return search_builder;
    },
    searchCandidates(where = false) {
      let params = {};
      if (where != false) {
        params["where"] = where;
      }
      params["search"] = "*";
      if (this.search !== "") params["search"] = this.search;

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      } else {
        params["order"] = {};
        params["order"]["created_at"] = "desc";
      }

      if (this.filter != {}) {
        params["filter"] = this.filter;
      }

      this.loading = true;
      axios
        .get(
          `/recruiters/talent_banks/candidates/search?page=${this.currentPage}`,
          { params: params }
        )
        .then((response) => {
          this.talent_banks = response.data.talent_banks;
          this.aggregators = response.data.aggregators;

          this.pageCount = Math.ceil(response.data.total_talent_banks / 30);
          this.firstLoad = false;
          this.loading = false;
          this.candidateCount = response.data.total_talent_banks;
        });
    },
  },
};
</script>


